// Generamos numero aleatorio para definir Keys para los elementos
export const numeroAleatorio = () => {
  return Math.random() * (100 - 1) + 1;
};
